// Used for when a sentence needs to be split into seperate elements for line wrapping purposes
export const sentenceSplit = (sentence: string) => {
  return sentence.split(' ').map((word, i) => (
    <span className="mb-2 md:mb-4" role="text" key={`${word}-${i}`}>
      {word}&nbsp;
    </span>
  ));
};
